const paymentConfig = {
  typeList: [
    // {
    //   type: 1,
    //   title: 'Epay',
    //   mIcon: require('@/assets/images/recharge/mobile/epay-check.png'),
    //   pcIcon: require('@/assets/images/recharge/pc/epay-check.png')
    // },
    {
      type: 8,
      title: 'crypto',
      mIcon: require('@/assets/images/recharge/mobile/mixpay-check.png'),
      pcIcon: require('@/assets/images/recharge/pc/mixpay-check.png'),
      product: ['xpoker-diamond1k', 'xpoker-diamond2k', 'xpoker-diamond3k', 'xpoker-diamond10k', 'xpoker-diamond20k', 'xpoker-diamond50k', 'xpoker-diamond100k', 'xpoker-diamond200k', 'xpoker-diamond500k', 'xpoker-diamond3', 'xpoker-diamond1', 'xpoker-diamond30'],
      isDev: false
    }
    // {
    //   type: 2,
    //   title: 'Triple-A',
    //   mIcon: require('@/assets/images/recharge/mobile/bitcoin-check.png'),
    //   pcIcon: require('@/assets/images/recharge/pc/bitcoin-check.png'),
    //   product: ['xpoker-diamond1k', 'xpoker-diamond2k', 'xpoker-diamond3k', 'xpoker-diamond10k', 'xpoker-diamond20k', 'xpoker-diamond50k', 'xpoker-diamond100k', 'xpoker-diamond200k', 'xpoker-diamond500k', 'xpoker-diamond3', 'xpoker-diamond1', 'xpoker-diamond30'],
    //   isDev: false
    // }
    // {
    //   type: 3,
    //   title: 'MoMo Pay (Only available in Vietnam)',
    //   mIcon: require('@/assets/images/recharge/mobile/momo-check.png'),
    //   pcIcon: require('@/assets/images/recharge/pc/momo-check.png'),
    //   product: ['xpoker-diamond3', 'xpoker-diamond30', 'xpoker-diamond2k', 'xpoker-diamond1k', 'xpoker-diamond3k', 'xpoker-diamond10k', 'xpoker-diamond20k', 'xpoker-diamond50k'],
    //   isDev: false
    // }
    // {
    //   type: 4,
    //   title: 'Vietnam Bank',
    //   mIcon: require('@/assets/images/recharge/mobile/vietnam_bank-check.png'),
    //   pcIcon: require('@/assets/images/recharge/pc/vietnam_bank-check.png'),
    //   product: ['xpoker-diamond3', 'xpoker-diamond30', 'xpoker-diamond10k', 'xpoker-diamond20k', 'xpoker-diamond50k'],
    //   isDev: true
    // }
  ]
}
export default paymentConfig



// WEBPACK FOOTER //
// ./src/util/payment.js